var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
import positionTooltip from './positioning';
var positionOrders = {
    top: ['top', 'bottom', 'right', 'left'],
    right: ['right', 'left', 'top', 'bottom'],
    bottom: ['bottom', 'top', 'right', 'left'],
    left: ['left', 'right', 'top', 'bottom']
};
export var Tooltip = AwsUi.__addComponent('awsui-tooltip', {
    releaseStatus: 'deprecated',
    properties: {
        // Where, relative to the trigger region, the tooltip should be
        // displayed.
        position: {
            type: 'string',
            valid: ['top', 'right', 'bottom', 'left'],
            defaultValue: 'right'
        },
        // If set, this property will make the tooltip contents wrap in multiple
        // lines. Otherwise (unset or set to `null`) it will just render in one line,
        // but the width of the tooltip will adjust to its contents.
        size: {
            type: 'string',
            nullable: true,
            valid: ['small', 'medium', 'large']
        },
        // Determines whether the tooltip is displayed to the user or not. This property is private.
        __visible: {
            type: 'boolean'
        },
        // Reflects if the user is hovering over the tooltip element
        __hoverTooltip: {
            type: 'boolean'
        }
    },
    regions: {
        // Elements that will trigger the tooltip when hovered.
        trigger: {
            isDefault: true
        },
        // Content of the tooltip.
        text: {}
    },
    render: function (m, h) {
        var component = this;
        if (!this.position || !this.text) {
            return h.region('trigger', 'span');
        }
        function trigger() {
            var triggerAttributes = {
                className: 'awsui-tooltip-trigger',
                onmouseover: function () { return (component.__visible = true); },
                onmouseleave: function () {
                    if (!component.__hoverTooltip) {
                        component.__visible = false;
                    }
                }
            };
            return h.region('trigger', 'span', triggerAttributes);
        }
        function getWrapperClass(position) {
            return new LegacyClassBuilder(component)
                .addComponentClass('wrap')
                .addComponentClass('visible', component.__visible)
                .addComponentClass("position-" + position)
                .toClassName();
        }
        function text() {
            var cb = new LegacyClassBuilder(component);
            cb.addComponentClass('text').addPropertyValueClass('size');
            var wrapperAttributes = {
                className: getWrapperClass(component.position),
                onmouseover: function () {
                    component.__hoverTooltip = true;
                    component.__visible = true;
                },
                onmouseleave: function () {
                    component.__hoverTooltip = false;
                    component.__visible = false;
                }
            };
            return AwsUi.__createElement("div", __assign({}, wrapperAttributes), h.region('text', 'div', { className: cb.toClassName() }));
        }
        function updatePosition(el) {
            var tooltip = el.querySelector('.awsui-tooltip-wrap');
            var trigger = el.querySelector('.awsui-tooltip-trigger');
            if (component.__visible) {
                var position = positionTooltip(tooltip, trigger, positionOrders[component.position]);
                tooltip.className = getWrapperClass(position);
            }
        }
        return (AwsUi.__createElement("span", { lifecycleKey: "awsui-tooltip", componentDidMount: updatePosition, componentDidUpdate: updatePosition },
            trigger(),
            text()));
    }
});
//# sourceMappingURL=index.js.map